(function () {
  "use strict";

  leftMenuService.$inject = ['mtypes', '$window'];
  angular
    .module('trainerWebApp.services')
    .factory('leftMenuService', leftMenuService);

  function leftMenuService(mtypes, $window) {

    var service = {
      featureEnabled: featureEnabled,
      redirectUrl: '/TrainerM/#/home'
    };

    return service;

    function featureEnabled() {
      return mfConfig.features.indexOf(mtypes.featureEntry.leftMenuMontara) !== -1;
    }
  }
})();
